import styled from "styled-components";

import { useTheme, useMediaQuery } from "@mui/material";

import { formattedCurrency } from "@/utils";
import { getClientCurrency, store } from "@/sheet/bidStore";
import { useEffect, useState } from "react";

export const FloatingBottomContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: nowrap;
    margin: 0 -10px;
    z-index: 3;
    font-size: 12px;
    background: ${(props) => props.theme.palette.background.paper};
    position: sticky;
    bottom: 30px;
    width: calc(100% + 20px);
    padding: 20px 20px 20px 40px;
    box-sizing: border-box;
    border-radius: 16px;
    box-shadow: 0px 0px 30px 0px
        ${(props) =>
            props.theme.palette.mode === "dark"
                ? "rgba(0, 0, 0, 0.5)"
                : "rgba(0, 0, 0, 0.2)"};
`;
const SectionLinks = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
`;
const SectionLink = styled.div`
    padding: 2px 20px;
    border-left: 1px solid #dddddd;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;

    &:first-child {
        padding-left: 0px;
        border-left: none;
    }
`;
const Detail = styled.div`
    margin-right: 24px;
    text-align: ${(props) => props.textAlign || "left"};
    flex-grow: ${(props) => props.flexGrow || 0};
    overflow-x: auto;

    ::-webkit-scrollbar {
        display: none;
    }

    h3 {
        font-weight: 400;
        font-size: 10px;
        margin: 0 0 6px 0;
        position: sticky;
        left: 0;
        top: 0;
    }

    p {
        font-weight: 600;
        font-size: 12px;
        margin: 0;
    }
`;
const SelectedSum = styled.div`
    background: ${(props) => props.theme.palette.background.paper};
    position: absolute;
    top: -45px;
    right: 0px;
    padding: 8px;
    border-radius: 6px;
    box-shadow: 0px 0px 30px 0px #00000040;
`;

export default function BidSum({
    bid: paramBid,
    registerSumDataFunction,
    isTemplate,
    onSectionLinkClick,
    isRunning,
}) {
    const [sumData, setSumData] = useState({});

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const activeBid = paramBid || store.bid;
    const bid = activeBid;
    const clientCurrency = paramBid?.project?.currency || getClientCurrency();
    const sections = activeBid.line_items_grouped || [];

    const selectedSum = formattedCurrency(sumData.selectedSum || 0);
    // const selectedAverage = formattedCurrency(((!sumData.selectedAverage || isNaN(sumData.selectedAverage)) ? 0 : sumData.selectedAverage))
    // const selectedCount = sumData.selectedCount || 0

    if (isTemplate == undefined) {
        return;
    }

    const sumOriginalTotalsStyle = isRunning
        ? {
              color: theme.palette.mode == "dark" ? "#FFFFFF66" : "#00000055",
          }
        : {};

    useEffect(() => {
        registerSumDataFunction(setSumData);
    }, []);

    return (
        <FloatingBottomContainer theme={theme}>
            {!isMobile && (
                <Detail flexGrow="1">
                    <h3>Sections</h3>
                    <SectionLinks>
                        {sections.map((section) => (
                            <SectionLink
                                key={section.id}
                                onClick={() => onSectionLinkClick(section.id)}
                            >
                                {section.name}
                            </SectionLink>
                        ))}
                    </SectionLinks>
                </Detail>
            )}

            {isRunning ? (
                <>
                    <Detail
                        textAlign="right"
                        style={{ minWidth: "fit-content" }}
                    >
                        <h3>{"Running Budget"}</h3>
                        <p data-testid="bid-total-budget">
                            {formattedCurrency(
                                bid.total_budget_running,
                                clientCurrency,
                            )}
                        </p>
                    </Detail>
                    <Detail
                        textAlign="right"
                        style={{ minWidth: "fit-content" }}
                    >
                        <h3>{"Variance"}</h3>
                        <p data-testid="bid-total-quoted">
                            {formattedCurrency(bid.variance, clientCurrency)}
                        </p>
                    </Detail>
                </>
            ) : null}

            <Detail textAlign="right" style={{ minWidth: "fit-content" }}>
                <h3 style={sumOriginalTotalsStyle}>{"Budget Total"}</h3>
                <p
                    style={sumOriginalTotalsStyle}
                    data-testid="bid-total-budget"
                >
                    {formattedCurrency(bid.total_budget, clientCurrency)}
                </p>
            </Detail>

            <Detail textAlign="right" style={{ minWidth: "fit-content" }}>
                <h3 style={sumOriginalTotalsStyle}>{"Quoted Total"}</h3>
                <p
                    style={sumOriginalTotalsStyle}
                    data-testid="bid-total-quoted"
                >
                    {formattedCurrency(bid.total_quoted, clientCurrency)}
                </p>
            </Detail>

            {selectedSum != 0 && (
                <SelectedSum theme={theme}>{`Sum: ${selectedSum}`}</SelectedSum>
            )}
        </FloatingBottomContainer>
    );
}
